import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_100')};
  padding: ${spacing('xl5')} ${spacing('md')};
  position: relative;
  overflow: hidden;
`;

export const StyledContainer = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xl')};
  z-index: 1;
  position: relative;
  max-width: ${container('md')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;
`;

export const StyledHeader = styled.div`
  text-align: center;
  margin-bottom: ${spacing('lg')};
  margin-left: auto;
  margin-right: auto;
  font-size: ${fontSize('md')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }

  ${Heading2}::before {
    background-color: ${color('info_500')};
  }

  p {
    color: ${color('text_subtle')};
  }
`;

export const StyledIcon = styled.div`
  background-color: ${color('info_500')};
  width: 8rem;
  height: 8rem;
  border-radius: ${radius('full')};
  margin: 0 auto ${spacing('xl2')};
  padding: ${spacing('lg')};
  display: flex;
  gap: ${spacing('md')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${color('text_white')};
  font-size: ${fontSize('sm')};
  line-height: 1.14;
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
`;
